module.exports = __webpack_public_path__ + "img/task-update.53f5a943.svg";